// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0987f409] .v-radio .v-label{color:#36134a!important}[data-v-0987f409] .v-radio{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
